
import { defineComponent, computed } from "vue";
import Modal from "../Components/Modal.vue";
import { useStore } from "../../stores";

export default defineComponent({
  name: 'InfoModal',

  setup() {
    const store = useStore();
    const infoText = computed(() => store.state.infoText);

    return { infoText };
  },

  methods: {
    onOkay(): void {
      this.$emit('close');
    },
  },

  components: { Modal },
});
